import { render, staticRenderFns } from "./IntegracionExpedienteIncodeV2.vue?vue&type=template&id=4be1d01e&scoped=true&"
import script from "./IntegracionExpedienteIncodeV2.vue?vue&type=script&lang=js&"
export * from "./IntegracionExpedienteIncodeV2.vue?vue&type=script&lang=js&"
import style0 from "./IntegracionExpedienteIncodeV2.vue?vue&type=style&index=0&id=4be1d01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1d01e",
  null
  
)

export default component.exports